// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	jQuery(document).ready(function() {
		jQuery(document).on('change', "input[name='are-you-interested-in-tyres']:checked", function(e) {
			var selected = e.currentTarget.value;

			if(selected == 'yes') {
				jQuery('#enquire-select-tyres').show();
			} else {
				jQuery('#enquire-select-tyres').hide();
			}
		})
	});

	jQuery(document).ready(function($) {
		// Temporarily disable CF7 Button on Submission
		$('.wpcf7-form').on('submit', function() {
			$(this).find('.wpcf7-submit').attr('disabled', true);
		});

		$('.wpcf7').on('wpcf7submit', function (e) {
			$(this).find('.wpcf7-submit').removeAttr('disabled');
		});
	});

} )();